import { useState } from "react";

import orionAPI from "../../../config/orionAPI";

const useEditUser = () => {
  const [isUserEdited, setIsUserEdited] = useState(false);
  const [loadingEditUser, setLoadingEditUser] = useState(true);
  const [editErrors, setEditErrors] = useState();
  const [isPasswordEmailSent, setIsPasswordEmailSent] = useState(false);
  const [loadingPasswordEmail, setLoadingPasswordEmail] = useState(false);

  const editUser = async (user) => {
    setLoadingEditUser(true);
    setIsUserEdited(false);

    await orionAPI
      .put(`/api/users/me`, user)
      .then((response) => {
        setIsUserEdited(true);
        window.location.reload();
      })
      .catch((error) => {
        setEditErrors(error.response.data.errors);
      })
      .finally(() => {
        setLoadingEditUser(false);
      });
  };

  const sendEditPasswordEmail = async (email) => {
    setLoadingPasswordEmail(true);
    setIsPasswordEmailSent(false);

    await orionAPI
      .post("/api/request_password_reset", {
        email: email,
      })
      .then(() => {
        setIsPasswordEmailSent(true);
      })
      .catch((error) => {
        console.error("Erro ao enviar email de reset:", error);
      })
      .finally(() => {
        setLoadingPasswordEmail(false);
      });
  };

  return {
    editUser,
    isUserEdited,
    loadingEditUser,
    editErrors,
    sendEditPasswordEmail,
    isPasswordEmailSent,
    loadingPasswordEmail,
  };
};

export default useEditUser;
